import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export default function InvitesCard() {
  const { setUser } = useAuth();
  const [invites, setInvites] = useState([]);

  useEffect(() => {
    api.get("/invites").then((r) => setInvites(r.data)).catch(() => {});
  }, []);

  if (invites.length === 0) return null;

  const respond = async (inv, action) => {
    try {
      await api.post(`/invites/${inv.id}/${action}`);
      if (action === "accept") {
        toast.success(`"${inv.account_name}" hesabına katıldınız`);
        const { data } = await api.post("/accounts/switch", { account_id: inv.account_id });
        setUser(data);
      } else {
        setInvites(invites.filter((i) => i.id !== inv.id));
      }
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div className="bg-primary/10 border border-primary/40 rounded-2xl p-5 space-y-3" data-testid="invites-card">
      <p className="text-sm font-semibold flex items-center gap-2">
        <Mail className="w-4 h-4 text-primary" /> Hesap Davetleriniz Var
      </p>
      {invites.map((inv) => (
        <div key={inv.id} data-testid={`invite-${inv.id}`}
          className="flex flex-col sm:flex-row sm:items-center gap-3 bg-card border border-border rounded-xl px-4 py-3">
          <p className="text-sm flex-1">
            <span className="font-semibold text-primary">{inv.invited_by}</span> sizi{" "}
            <span className="font-semibold">"{inv.account_name}"</span> hesabına davet etti
          </p>
          <div className="flex gap-2">
            <Button data-testid={`accept-invite-${inv.id}`} size="sm" onClick={() => respond(inv, "accept")}
              className="rounded-full font-semibold">Kabul Et</Button>
            <Button data-testid={`reject-invite-${inv.id}`} size="sm" variant="ghost" onClick={() => respond(inv, "reject")}
              className="rounded-full text-muted-foreground">Reddet</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
